import { ReactComponent as LanguageIconSVG } from "./language.svg";
import { SvgIcon } from '@mui/material';

export default function IconLanguage(props) {
  return <SvgIcon {...props} component={LanguageIconSVG} viewBox="0 0 18 18" />;
}